import { UnaryFunction } from 'rxjs/interfaces';

import { Logger } from './../../api';
import { noop } from './../misc';

// method shortcuts
const _console = console;
const CONSOLE_INFO = _console.info;
const CONSOLE_ERROR = _console.error;
const CONSOLE_WARN = _console.warn;

// our default depending on the environment
export const createConsoleLogger: UnaryFunction<string, Logger> = aName => ({
  'info': CONSOLE_INFO.bind(_console, aName),
  'warn': CONSOLE_WARN.bind(_console, aName),
  'error': CONSOLE_ERROR.bind(_console, aName)
});

export const createEmptyLogger: UnaryFunction<string, Logger> = aName => ({
  'info': noop,
  'warn': noop,
  'error': CONSOLE_ERROR.bind(_console, aName)
});
